import { KipaCard, BottomButtonContainer } from "@/components/kipa";
import KipaIcon from "@/components/kipa/KipaIcon";
import { CircleDollarSign, Compass, Package } from "lucide-react";

const INTENTS = [
  {
    id: "inventory",
    icon: Package,
    title: "Set up my products",
    desc: "Add the products or services you sell so KipaBiz can track stock and calculate profit",
  },
  {
    id: "sales",
    icon: CircleDollarSign,
    title: "Record a sale",
    desc: "Already made a sale today? Tell your accountant and get started immediately",
  },
  {
    id: "explore",
    icon: Compass,
    title: "Explore KipaBiz first",
    desc: "Take a quick tour to see everything KipaBiz can do for your business",
  },
];

/**
 * First-login welcome — shown once before the main dashboard.
 */
export default function LoginIntentPrompt({
  open,
  businessName,
  accountantName = "Kola",
  onSelect,
  onDismiss,
}) {
  if (!open) return null;

  const name = businessName?.trim() || "there";

  return (
    <div
      className="fixed inset-0 z-[60] flex items-end justify-center kipa-sheet-overlay"
      data-testid="login-intent-prompt"
    >
      <div
        className="kipa-sheet w-full max-w-[430px]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-10 h-1 rounded-full bg-[var(--color-border)] mx-auto mb-5" />
        <h2
          className="text-[var(--text-lg)] font-black text-[var(--color-text-primary)] text-center mb-1 leading-snug"
          data-testid="login-intent-headline"
        >
          Welcome to KipaBiz, {name}!
        </h2>
        <p className="text-[var(--text-sm)] text-[var(--color-text-secondary)] text-center mb-5 leading-relaxed">
          Where would you like to start?
        </p>

        <div className="space-y-3 mb-4">
          {INTENTS.map((item) => (
            <KipaCard
              key={item.id}
              onPress={() => onSelect(item.id)}
              testId={`login-intent-${item.id}`}
              padding={16}
              marginBottom={0}
              className="flex items-center gap-3.5 !flex-row"
            >
              <div className="w-11 h-11 rounded-xl bg-[var(--color-primary-light)] border border-[var(--color-primary-dim)] flex items-center justify-center flex-shrink-0">
                <KipaIcon icon={item.icon} size="md" color="var(--color-primary)" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-[var(--text-sm)] font-extrabold text-[var(--color-text-primary)]">
                  {item.title}
                </div>
                <div className="text-[var(--text-sm)] text-[var(--color-text-secondary)] mt-0.5 leading-snug">
                  {item.desc}
                </div>
              </div>
              <span className="text-[var(--color-text-muted)] text-[18px]">→</span>
            </KipaCard>
          ))}
        </div>

        <button
          type="button"
          onClick={onDismiss}
          data-testid="login-intent-skip-dashboard"
          className="w-full text-center text-[var(--text-sm)] text-[var(--color-text-muted)] font-semibold py-2"
        >
          Go straight to dashboard →
        </button>
      </div>
    </div>
  );
}
